import { IAction, isType } from '@zaibot/fsa';

import NOTECHAT_LOADED from './actions/NOTECHAT_LOADED';
import NOTECHAT_NOT_LOADED from './actions/NOTECHAT_NOT_LOADED';

import { INoteChat } from '../../types';
import NOTECHAT_TOGGLE_MENU from './actions/NOTECHAT_TOGGLE_MENU';
import NOTECHATATTACHED_TOGGLE_MENU from './actions/NOTECHATATTACHED_TOGGLE_MENU';

interface IState {
  notechat: INoteChat;
  showMiniMenuChat: boolean;
  showMiniMenuChatAttached: boolean;
  itemMiniMenuChat: INoteChat;
}
const emptyState: IState = {
  notechat: {userId:'', noteId:0, created:new Date(Date.now()).valueOf(), text: '', id: 0} as INoteChat,
  showMiniMenuChat: false,
  showMiniMenuChatAttached: false,
  itemMiniMenuChat: undefined,
};

export const selector = (state: any) => state.notechat as IState;

export const reducer = (state = emptyState, action: IAction) => {  
  if (isType(action, NOTECHAT_NOT_LOADED)) {
    return { ...state };
  } 
  if (isType(action, NOTECHAT_LOADED)) {
    return { ...state };
  }  
  if (isType(action, NOTECHAT_TOGGLE_MENU)) {
    return { ...state, showMiniMenuChat: action.payload.showMiniMenuChat, itemMiniMenuChat: action.payload.itemMiniMenuChat  };
  } 
  if (isType(action, NOTECHATATTACHED_TOGGLE_MENU)) {
    return { ...state, showMiniMenuChatAttached: action.payload.showMiniMenuChatAttached, itemMiniMenuChatAttached: action.payload.itemMiniMenuChatAttached  };
  } 
  return state; 
};



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/notechat/reducer.tsx